import React, { useState, useEffect } from 'react'
import { showData } from '../../Utils/APIs/commonShowAPI'
import axios from "axios";
import DatePicker from "react-datepicker";
import formatDateToIST from '../../Utils/date/formatDateToIST.js';
import insuranceExcel from '../../Assets/Excel/Insurance.xlsx';
axios.defaults.withCredentials = true;
const InsuranceList = () => {
    const [insuranceList, setInsuranceList] = useState([]);
    const [saralId, setSaralId] = useState('');
    const [receiveAmount, setReceiveAmount] = useState();

    const [startDate, setStartDate] = useState();
    useEffect(() => {
        const findList = async () => {
        await showData(`account/insuranceList`, setInsuranceList);
        }
        findList();
    }, []);

    const saveInsuranceData = async() => {
        if(!saralId || !receiveAmount || !startDate){
            alert('Please fill all the fields');
            return;
        }
        const data = {
            saralId,
            receiveAmount: Number(receiveAmount),
            paymentReceiveDate: formatDateToIST(startDate)
        }
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/account/saveInsuranceData`, data);
            if (response.data.success) {
            alert(response?.data?.message || 'Data saved successfully');
            setSaralId('');
            setReceiveAmount('');
            setStartDate(null);
            } else {
            alert(response?.data?.data?.message || 'Failed to save data');
            }
        } catch (error) {
            alert(error?.response?.data?.message|| 'Something went wrong');
        }
    }
    const[insuranceFile, setInsuranceFile] = useState(null);
    const uploadInsuranceFile = async() => {
        const formData = new FormData();
        formData.append('file', insuranceFile);
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/account/uploadInsuranceFile`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (response.data.success) {
                alert(response?.data?.message || 'File uploaded successfully');
                setInsuranceFile(null);
            } else {
                alert(response?.data?.message || 'Failed to upload file');
            }
        } catch (error) {
            alert(error?.response?.data?.message || 'Something went wrong');
        }
    }
return (
    <div className="w-auto flex flex-col">
        <div className="mainHeading">
            <h1 className='text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50 rounded-lg'>
                T<span className='text-lg'>RANSPORT</span> P<span className='text-lg'>AYMENT</span> S<span className='text-lg'>YSTEM</span>
            </h1>
        </div>

        {/* Scroll wrapper */}
            <div className="w-full mt-10">
                    <div className="grid gap-3 m-6 md:grid-cols-4">
                            <div>
                                <label for="saral_id" className="block mb-2 text-sm font-medium text-gray-900">Saral ID<span className='text-red-500 relative h-3'>*</span></label>
                                <input type="text" id="saral_id" onChange={(e) => { setSaralId(e.target.value) }} value={saralId} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5 uppercase" placeholder="Saral Id" required />
                            </div>
                            <div>
                                <label for="receive_amount" className="block mb-2 text-sm font-medium text-gray-900 ">Receive Amount<span className='text-red-500 relative h-3'>*</span></label>
                                <input type="text" id="receive_amount" onChange={(e) => { setReceiveAmount(e.target.value) }} value={receiveAmount} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5" placeholder="Receive Amount" required />
                            </div>
                            <div>
                                <label htmlFor="date-range" className="block mb-2 text-sm font-medium text-gray-900 ">
                                        Payment Receive Date<span className='text-red-500 relative h-3'>*</span>
                                </label>
                                <DatePicker
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    selectsStart
                                    placeholderText="Date"
                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block p-2.5 pr-24"
                                />
                            </div>
                            <button 
                                type="button" 
                                onClick={saveInsuranceData} 
                                className="text-white mt-7 bg-blue-500 hover:bg-blue-600 font-medium rounded-sm text-sm w-full px-5 py-2.5 text-center"
                            >Save
                            </button>
                    </div>
                    <div className="grid gap-3 m-6 md:grid-cols-4">
                        <div>
                            <label htmlFor="date-range" className="block mb-2 text-sm font-medium text-gray-900 ">Upload Document<span className='text-red-500 relative h-3'>*</span></label>
                            <input
                                type="file"
                                accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                onChange={(e)=>setInsuranceFile(e.target.files[0])}
                                className="mt-2"
                            />
                            <a href={insuranceExcel} download="insurance.xlsx" className='text-sm text-blue-600'>Download Format</a>
                        </div>
                        <button 
                            type="button" 
                            onClick={uploadInsuranceFile} 
                            className="text-white mt-7 bg-blue-500 hover:bg-blue-600 font-medium rounded-sm text-sm w-full h-10 px-5 py-2.5 text-center"
                        >Upload
                        </button>
                    </div>
            </div>
    </div>
)
}

export default InsuranceList;
